import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  Text,
  Flex,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from '@chakra-ui/react'
import React from 'react'
import { forwardRef } from 'react'
import * as T from '../Table'
import { useState } from 'react'
import { FaArrowLeft, FaPhone, FaUser } from 'react-icons/fa'
import { MdOutlineMail, MdOutlinePhoneIphone, MdPhoneInTalk } from 'react-icons/md'
import { useModalCallPhone } from '../../contexts/CallPhoneContext'
import { addSeconds, format, parseISO } from 'date-fns'
import { Button } from '../Button'
import { Box, CircularProgress, useToast } from '@chakra-ui/react'
import { GiPauseButton, GiPlayButton } from 'react-icons/gi'
import { IoIosPhonePortrait } from 'react-icons/io'
import { phoneMask } from '../../services/mask'
import { user } from '../../helpers/user'
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta'

export function Telefone({
  email_contato,
  telefone_parceiro,
  nome_cliente,
  celular_parceiro,
  codigo_vendedor,
  info_ligacoes,
  nome_contato,
  contatos,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [showHistory, setShowHistory] = useState(false)

  const list = info_ligacoes?.map((data) => {
    const dataInicio = parseISO(data?.inicioLigacao)
    const duracao = parseInt(data?.duracao, 10) // converte a duração para número

    // Adicionar a duração em segundos à data de início
    const dataFim = addSeconds(dataInicio, duracao)

    return {
      data: data.data ? format(new Date(data.data), "dd/MM/yyyy 'às' HH:mm") : '',
      consultor: data.consultor,
      atendimento: data.atendimento,
      inicioLigacao: format(dataInicio, "dd/MM/yyyy 'às' HH:mm"), // adiciona o início da ligação
      terminoLigacao: format(dataFim, "dd/MM/yyyy 'às' HH:mm"), // adiciona o término da ligação
      duracao: data.duracao ? format(new Date(duracao * 1000), 'mm:ss') : '',
      audio: {
        url: data.audio,
        id: data.duracao,
      },
      telefone: data.telefone ? phoneMask(data.telefone) : '',
    }
  })

  return (
    <>
      <Icon
        onClick={onOpen}
        as={FaPhone}
        color={info_ligacoes?.length > 0 ? '#25D366' : '#378BBF'}
        fontSize="20px"
        _hover={{
          cursor: 'pointer',
          transform: 'scale(1.1)',
        }}
        transition="all 0.2s"
      />

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="5xl">
        <ModalOverlay />
        <ModalContent maxH="90vh">
          <Flex
            position="absolute"
            top="3"
            right="3"
            alignItems="center"
            justifyContent="center"
            fontSize="13px"
            color="#1C2126"
            textTransform={'uppercase'}
            fontWeight="bold"
            onClick={onClose}
            cursor="pointer"
            _hover={{ color: '#378BBF' }}
          >
            <ModalCloseButton _focus={{ outline: 'none' }} position="relative" top="0" right="0" color="#378BBF" />
            Fechar
          </Flex>
          {!showHistory && (
            <ModalBody display="flex" flexDir="column" my="75px" gap="20px" minH="300px">
              <Flex alignItems="center" gap={2} px={2} py={2}>
                <Icon as={FaUser} color="#378BBF" fontSize="25px" />
                <Text>
                  <Text as="span" fontWeight="semibold">
                    CLIENTE:
                  </Text>{' '}
                  {nome_cliente}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2} px={2} py={2}>
                <Icon as={FaUser} color="#378BBF" fontSize="25px" />
                <Text>
                  <Text as="span" fontWeight="semibold">
                    NOME:
                  </Text>{' '}
                  {nome_contato}
                </Text>
              </Flex>
              <Flex alignItems="center" gap={2} px={2} py={2}>
                <Icon as={MdOutlineMail} color="#378BBF" fontSize="25px" />
                <Text>
                  <Text as="span" fontWeight="semibold">
                    EMAIL:
                  </Text>{' '}
                  {email_contato}
                </Text>
              </Flex>

              {contatos?.length > 0 && (
                <Flex alignItems="center" gap={2} px={2} py={2}>
                  <Icon as={FaUser} color="#378BBF" fontSize="25px" />
                  <Text>
                    <Text as="span" fontWeight="semibold">
                      CONTATOS:
                    </Text>{' '}
                    {contatos.map((contato) => contato).join(', ')}
                  </Text>
                </Flex>
              )}

              <Item number={celular_parceiro?.trim()} label="TELEFONE" icon={MdOutlinePhoneIphone} />
              <Item number={telefone_parceiro?.trim()} label="FIXO" icon={MdPhoneInTalk} />

              <Button
                maxW="fit-content"
                w="100%"
                ml="5px"
                display="flex"
                alignItems="center"
                disabled={info_ligacoes.length === 0}
                onClick={() => setShowHistory(!showHistory)}
              >
                <Icon as={FaPhone} fontSize="20px" mr={2} />
                Ver histórico de ligações
              </Button>
            </ModalBody>
          )}

          {showHistory && (
            <>
              <ModalBody minH="230px" mt="10" maxH="100%" overflowY="auto">
                <T.Table maxW="1339px" mx="auto" borderCollapse="collapse" variant="outline">
                  <ColumnsHistoryCall />
                  <T.Tbody>
                    <ListHistoryCall list={list} />
                  </T.Tbody>
                </T.Table>
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={() => setShowHistory(!showHistory)}
                  mt="auto"
                  maxW="fit-content"
                  w="100%"
                  ml="5px"
                  display="flex"
                  alignItems="center"
                >
                  <Icon as={FaArrowLeft} fontSize="20px" mr={2} />
                  Voltar
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}

const Item = ({ number, label, icon }) => {
  const [isHovered, setIsHovered] = useState(false)
  const { openCallPhone } = useModalCallPhone()

  return (
    <Flex
      alignItems="center"
      position="relative"
      gap={2}
      cursor="pointer"
      py={2}
      px={2}
      onClick={() => openCallPhone(number)}
      _hover={{
        bgColor: '#378BBF',
        color: 'white!important',
        //svg
        '> svg': {
          color: 'white!important',
        },
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon as={icon} color="#378BBF" fontSize="25px" />
      <Text>
        <Text as="span" fontWeight="semibold">
          {label}:
        </Text>{' '}
        {number}
      </Text>

      {!!number && isHovered && (
        <Text position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" color="white">
          Iniciar ligação
        </Text>
      )}
    </Flex>
  )
}

export function ColumnsHistoryCall() {
  return (
    <T.Thead>
      <T.Tr>
        <T.Th>Data</T.Th>
        <T.Th>Consultor</T.Th>
        <T.Th>Atendimento</T.Th>
        <T.Th>Início da Ligação</T.Th>
        <T.Th>Término da Ligação</T.Th>
        <T.Th>Duração</T.Th>
        <T.Th />
      </T.Tr>
    </T.Thead>
  )
}

export function ListHistoryCall({ list }) {
  const [currentAudioPlaying, setCurrentAudioPlaying] = useState(null)

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  console.log(currentAudioPlaying)
  function playSound(audio, callback) {
    if (!permissoesUsuariosPropostas[user.codigo_usuario]) {
      return
    }

    const audioPlaying = audio.current

    if (currentAudioPlaying) {
      currentAudioPlaying.pause()
      setCurrentAudioPlaying(null)
    }

    audioPlaying
      .play()
      .then(() => {
        setCurrentAudioPlaying(audioPlaying)
        callback()
      })
      .catch(() => {
        toast({
          title: 'Erro',
          description: 'Não foi possível reproduzir o áudio.',
          status: 'error',
        })
      })
  }

  return list.map((data, index) => (
    <ItemHistoryCall key={index} item={data} isOdd={index % 2 === 0} playSound={playSound} currentAudioPlaying={currentAudioPlaying} />
  ))
}

export const ItemHistoryCall = ({ item, isOdd, playSound, currentAudioPlaying }) => {
  const audioRef = React.useRef(null)
  const [audioIsPlaying, setAudioIsPlaying] = React.useState(false)
  const [currentTime, setCurrentTime] = React.useState(0)
  const [duration, setDuration] = React.useState(0)
  const [error, setError] = React.useState(null)

  function handlePlayAudio() {
    playSound(audioRef, () => {
      setAudioIsPlaying(true)
      setDuration(audioRef.current.duration)
    })
  }

  function stopSound() {
    const audio = audioRef.current
    audio.pause()
    setAudioIsPlaying(false)
  }

  const handleTimeUpdate = () => {
    const audio = audioRef.current
    setCurrentTime(audio.currentTime)
  }

  function onAudioEnded() {
    setAudioIsPlaying(false)
  }

  return (
    <T.Tr>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'}>{item.data}</T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.consultor}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        <Flex alignItems="center" justifyContent="center" gap={2} mx="auto">
          <Icon as={IoIosPhonePortrait} fontSize="25px" color="#378BBF" />
          <strong>CELULAR:</strong> {item.telefone}
        </Flex>
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.inicioLigacao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.terminoLigacao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        {item.duracao}
      </T.Td>
      <T.Td bgColor={isOdd ? '#EDF2F7' : 'white'} borderLeft="1px solid #CFCFCF">
        <Flex alignItems="center" justifyContent="center" gap="10px" w="70px" mx="auto" position="relative">
          <Box position="relative" w="25px">
            <CircularProgress
              value={(currentTime * 100) / duration}
              size="25px"
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              color="#378BBF"
            />
            <Icon
              as={currentAudioPlaying === audioRef.current && audioIsPlaying ? GiPauseButton : GiPlayButton}
              fontSize="15px"
              color={!error ? '#378BBF' : 'red.500'}
              cursor="pointer"
              //toggle play/pause
              onClick={() => (currentAudioPlaying === audioRef.current && audioIsPlaying ? stopSound() : handlePlayAudio())}
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          </Box>
          <Sound ref={audioRef} src={item.audio.url} onTimeUpdate={handleTimeUpdate} onAudioEnded={onAudioEnded} />

          <Slider
            aria-label="slider-ex-1"
            size="sm"
            max={duration}
            value={currentTime}
            disabled={!audioIsPlaying}
            onChange={(value) => {
              audioRef.current.currentTime = value
              setCurrentTime(value)
            }}
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>

          {/* {audioIsPlaying && (
            <Text
              fontSize="10px"
              color="#378BBF"
              position="absolute"
              top="50%"
              right="-25px"
              transform="translateY(-50%)">
              {currentTime.toFixed(0)}s / {duration.toFixed(0)}s
            </Text>
          )} */}
        </Flex>
      </T.Td>
    </T.Tr>
  )
}

export const Sound = forwardRef(({ src, onTimeUpdate, onAudioEnded }, ref) => {
  return <audio ref={ref} src={src} onTimeUpdate={onTimeUpdate} onEnded={onAudioEnded} />
})
